import { Icon } from "../icons/Icon";

export interface LinkButton { label: string; href: string; }

/** The customer sidebar round (2026-11-01): a row of links that look like the kit's small secondary buttons, each a real `<a>` (so it can
 *  be copied and middle-clicked) opening the team's own tool in a new tab without telling it where it came from. No links: nothing. */
export function LinkButtons({ links, label = "Customer links" }: { links: LinkButton[]; label?: string }) {
  if (!links.length) return null;
  return (
    <div className="ob-link-buttons" role="group" aria-label={label}>
      {links.map((l) => (
        <a key={`${l.label}|${l.href}`} className="ob-btn ob-btn--secondary ob-btn--sm" href={l.href} target="_blank" rel="noopener noreferrer">
          <Icon name="openInNew" size="sm" />{l.label}
        </a>
      ))}
    </div>
  );
}
